import { render } from "./WalletDataButton.vue?vue&type=template&id=d05d7ca4&scoped=true"
import script from "./WalletDataButton.vue?vue&type=script&lang=js"
export * from "./WalletDataButton.vue?vue&type=script&lang=js"

import "./WalletDataButton.vue?vue&type=style&index=0&id=d05d7ca4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d05d7ca4"

export default script